import React from "react";
import { useSelector } from "react-redux";

import { CategoryPageSkeleton } from "../../component/skeleton/CategoryPageSkeleton";
import { CancellationTablePage } from "./cancellationTable/cancellationTablePage";
import { CancellationFilterPage } from "./cancellationFilter/CancellationFilterPage";
import {
    selectCancellations,
    useGetCancellationsListQuery,
} from "../../services/cancellationApiSlice";

import classes from "./cancellationPage.module.css";
import { selectCancellationState } from "../../store/cancellationFilterSlice";

export const CancellationPage = () => {
  const appliedFilters = useSelector(selectCancellationState);
  const { isSuccess } = useGetCancellationsListQuery(appliedFilters,{
  refetchOnMountOrArgChange: true
});

  const tableData = useSelector(selectCancellations);

  return isSuccess ? (
    <div className={classes.box}>
      <CancellationFilterPage filters ={appliedFilters}/>
      <CancellationTablePage data={tableData} />
    </div>
  ) : (
    <CategoryPageSkeleton />
  );
};
